import React, { useLayoutEffect, useState, useEffect } from 'react'
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import './styles/globals.css'
import './index.css'
import MyContext from './contexts/myContext'

import Home from './pages/Home';
import Login from './pages/Login'
import Departamentos from './pages/Departamentos';
import CadastroDashBoard from './pages/CadastroDashBoard';
import CadastroImagens from './pages/CadastroImagens';
import CadastroEmpresas from './pages/CadastroEmpresas';
import CadastroUsuarios from './pages/CadastroUsuarios';
import DashPorDepartamento from './pages/DashPorDepartamento';
import RenderLinkDash from './pages/RenderLinkDash';

import MenuLateral from './components/MenuLateral';
import { MenuSuperiorMobile } from './components/MenuSuperiorMobile';


import Carrossel from './Carrossel/Carrossel';
import B2B_CotacaoVendas from './DashNativos/B2B_CotacaoVendas';
import B2B_NotaFiscal from './DashNativos/B2B_NotaFiscal';
import B2B_NotaFiscalServico from './DashNativos/B2B_NotaFiscalServico';
import B2B_TitulosPendentesVencidos from './DashNativos/B2B_TitulosPendentesVencidos';
import B2B_HistoricoTitulos from './DashNativos/B2B_HistoricoTitulos';
import B2B_PedidosPDV from './DashNativos/B2B_PedidosPDV';
import B2B_Maquinas from './DashNativos/B2B_Maquinas';
import B2B_MovimentacoesFiscais from './DashNativos/B2B_MovimentacoesFiscais';
import B2B_ContasPagarReceberEmAberto from './DashNativos/B2B_ContasPagarReceberEmAberto';
import B2B_Contratos from './DashNativos/B2B_Contratos';
import B2B_CotacaoContratos from './DashNativos/B2B_CotacaoContratos';
import B2B_FaturaContratos from './DashNativos/B2B_FaturaContratos';
import B2B_OrdemServico from './DashNativos/B2B_OrdemServico';

import { api } from './services/api';

const App = () => {
  const [user, setUser] = useState({})
  const [hideBar, setHidebar] = useState(false)
  const [vCloseKPI, setvCloseKPI] = useState('')

  const [tabsAbertas, setTabsAbertas] = useState([]);
  const [tabAtual, setTabAtual] = useState('');
  const [Departamento, setDepartamento] = useState('');
  const [LinkDash, setLinkDash] = useState('');
  const [barraLateral, setBarraLateral] = useState(true)
  const [dadosDash, setDadosDash] = useState([])

  const getDadosDashBoard = async () => {
    await api
      .get('/dashboard/api/listaDashboard')
      .then(data => {
        setDadosDash(data.data)
      })
      .catch(error => console.log(error))
  }

  useEffect(() => {
    getDadosDashBoard()
  }, [])

  useEffect(() => {
    addTab('OPÇÕES')
  }, [])

  function addTab(tab) {

    setTabAtual(tab)

    //Se já existe então não cria a mesma aba novamente
    if (tabsAbertas.filter(tabs => tabs.name == tab).length === 0) {
      let arrTabs = tabsAbertas

      let vID = Math.floor(Date.now() * Math.random()).toString(36)

      arrTabs.push({
        name: tab,
        id: vID
      })

      setTabsAbertas(arrTabs)
    }
  }

  function removeTab(tab) {

    setTabsAbertas(tabsAbertas.filter(tabs => tabs.name !== tab))
    if (tabsAbertas.filter(tabs => tabs.name !== tab).length > 1) {
      if (tab === tabAtual) {
        setTabAtual(tabsAbertas.filter(tabs => tabs.name !== tab)[1].name)
      }
    }
    else {
      setTabAtual('')
    }
  }


  function setarUsuario(user) {
    if (user) {
      setUser(user)
    }
  }

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  }


  function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useLayoutEffect(() => {
      function handleResize() {
        setWindowDimensions(getWindowDimensions());
      }

      window.addEventListener('resize', handleResize, { passive: true });
      return () => window.removeEventListener('resize', handleResize, { passive: true });
    }, []);

    return windowDimensions;
  }

  const { height, width } = useWindowDimensions();


  useEffect(() => {
    try {
      /*
      const loggedInUser = localStorage.getItem("Nome_User");
      
      if (loggedInUser && localStorage.manterLogin === "true") {
        setUser({
          Nome: loggedInUser,
          idUsuario: localStorage.idUsuario_User,
          GodMode: localStorage.GodMode_User,
          cnpj: localStorage.cnpj_User,
          senha: localStorage.senha_User,
        });

      }
      else {
        localStorage.manterLogin = "false"
        localStorage.userMantido = ""
        setUser({});
      }*/
    } catch (error) {

    }

  }, [])

  return (
    <MyContext.Provider value={
      {
        user, setUser,
        hideBar, setHidebar,
        tabsAbertas, setTabsAbertas,
        tabAtual, setTabAtual,
        Departamento, setDepartamento,
        LinkDash, setLinkDash,
        barraLateral, setBarraLateral,
        addTab, removeTab,
        vCloseKPI, setvCloseKPI
      }
    }>


      {user?.Nome ?
        <Router>
          <div style={{ display: 'flex', flexDirection: width < 801 ? 'column' : 'row', height: '100vh', width: '100%' }}>
            <div style={{ display: hideBar ? 'none' : 'block' }} >

              {width < 801 ?
                <MenuSuperiorMobile />
                :
                <>
                  <MenuLateral />
                </>
              }
            </div>
            <Switch>
              <Route path='/' exact component={Home} />
              <Route path='/loginmaispratico/:user/:senha/:cnpj' exact component={Home} />
              <Route path='/departamentos' exact component={Departamentos} />
              <Route path='/cadastrodashboard' exact component={CadastroDashBoard} />
              <Route path='/cadastroimagens' exact component={CadastroImagens} />
              <Route path='/cadastroempresas' exact component={CadastroEmpresas} />
              <Route path='/cadastrousuarios' exact component={CadastroUsuarios} />
              <Route path='/dashpordepartamento/:departamento' exact component={DashPorDepartamento} />
              <Route path='/renderlinkdash/:linkdash' exact component={RenderLinkDash} />

              { /* DASH B2B*/}
              <Route path='/B2B_CotacaoVendas/:NomeAmigavel/:hideBar' exact component={B2B_CotacaoVendas} />
              <Route path='/B2B_CotacaoVendas/:NomeAmigavel' exact component={B2B_CotacaoVendas} />
              <Route path='/B2B_NotaFiscal/:NomeAmigavel/:hideBar' exact component={B2B_NotaFiscal} />
              <Route path='/B2B_NotaFiscal/:NomeAmigavel' exact component={B2B_NotaFiscal} />
              <Route path='/B2B_NotaFiscalServico/:NomeAmigavel/:hideBar' exact component={B2B_NotaFiscalServico} />
              <Route path='/B2B_NotaFiscalServico/:NomeAmigavel' exact component={B2B_NotaFiscalServico} />
              <Route path='/B2B_TitulosPendentesVencidos/:NomeAmigavel/:hideBar' exact component={B2B_TitulosPendentesVencidos} />
              <Route path='/B2B_TitulosPendentesVencidos/:NomeAmigavel' exact component={B2B_TitulosPendentesVencidos} />
              <Route path='/B2B_HistoricoTitulos/:NomeAmigavel/:hideBar' exact component={B2B_HistoricoTitulos} />
              <Route path='/B2B_HistoricoTitulos/:NomeAmigavel' exact component={B2B_HistoricoTitulos} />
              <Route path='/B2B_PedidosPDV/:NomeAmigavel/:hideBar' exact component={B2B_PedidosPDV} />
              <Route path='/B2B_PedidosPDV/:NomeAmigavel' exact component={B2B_PedidosPDV} />
              <Route path='/B2B_Maquinas/:NomeAmigavel/:hideBar' exact component={B2B_Maquinas} />
              <Route path='/B2B_Maquinas/:NomeAmigavel' exact component={B2B_Maquinas} />
              <Route path='/B2B_MovimentacoesFiscais/:NomeAmigavel/:hideBar' exact component={B2B_MovimentacoesFiscais} />
              <Route path='/B2B_MovimentacoesFiscais/:NomeAmigavel' exact component={B2B_MovimentacoesFiscais} />
              <Route path='/B2B_ContasPagarReceberEmAberto/:NomeAmigavel/:hideBar' exact component={B2B_ContasPagarReceberEmAberto} />
              <Route path='/B2B_ContasPagarReceberEmAberto/:NomeAmigavel' exact component={B2B_ContasPagarReceberEmAberto} />
              <Route path='/B2B_Contratos/:NomeAmigavel/:hideBar' exact component={B2B_Contratos} />
              <Route path='/B2B_Contratos/:NomeAmigavel' exact component={B2B_Contratos} />
              <Route path='/B2B_CotacaoContratos/:NomeAmigavel/:hideBar' exact component={B2B_CotacaoContratos} />
              <Route path='/B2B_CotacaoContratos/:NomeAmigavel' exact component={B2B_CotacaoContratos} />
              <Route path='/B2B_FaturaContratos/:NomeAmigavel/:hideBar' exact component={B2B_FaturaContratos} />
              <Route path='/B2B_FaturaContratos/:NomeAmigavel' exact component={B2B_FaturaContratos} />
              <Route path='/B2B_OrdemServico/:NomeAmigavel/:hideBar' exact component={B2B_OrdemServico} />
              <Route path='/B2B_OrdemServico/:NomeAmigavel' exact component={B2B_OrdemServico} />

              {dadosDash.filter(aberta => aberta.Descricao === localStorage.DescricaoDashAtual && aberta.opTipoDash === 'CARROSSEL').length > 0 ?
                dadosDash.filter(tab => tab.Descricao === localStorage.DescricaoDashAtual && tab.opTipoDash === 'CARROSSEL').map(tab => {
                  return (
                    <>
                      <Route path={`/${tab.Descricao}/:NomeInterno`} exact component={Carrossel} />
                      <Route path={`/${tab.Descricao}/:NomeInterno/:hideBar`} exact component={Carrossel} />
                    </>
                  )
                })

                :
                null
              }
            </Switch>
          </div>
        </Router>
        :
        <Login setarUsuario={setarUsuario} />
      }

    </MyContext.Provider>
  )
}

export default App;